export default "__VITE_ASSET__DyGL3BSQ__"